module.exports = __webpack_public_path__ + "img/cookie.74c7d49d.png";